import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardFooter, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';

import { parseQuery } from '../../../../util/parser';

// Import Components
import UserLoginForm from '../../components/auth/UserLoginForm';
import UserNewPassword from '../../components/auth/UserNewPassword';

import User from '../../User';

function UserLoginPage(props) {
    const { location, intl, redirect } = props;
    const query = parseQuery(location.search);

    return (
        <Container fluid className="py-3">
            <Helmet
                title={intl.formatMessage({ id: 'userLogin', defaultMessage: 'Login' })}
                // meta={[
                //     {
                //         name: 'robots',
                //         content: 'noindex',
                //     },
                // ]}
            />
            <Row noGutters>
                <Col sm={{ size: 10, offset: 1 }} md={{ size: 8, offset: 2 }} lg={{ size: 4, offset: 4 }}>
                    <Card className="shadow">
                        <CardBody>
                            <UserLoginForm redirect={redirect || null} email={query.email} password={query.password} code={query.code} />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

UserLoginPage.defaultProps = {
    location: { params: {} },
    redirect: '',
};

UserLoginPage.propTypes = {
    location: PropTypes.object,
    intl: intlShape.isRequired,
    redirect: PropTypes.string,
};

export default injectIntl(UserLoginPage);
